exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Image__container___3NXZi {\n  -ms-flex-item-align: center;\n      align-self: center;\n  border: 1px solid #dfe5ec;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 8px;\n  margin: 16px 0;\n  width: 60%;\n}\n\n.Image__img___2fY-M {\n  width: 100%;\n}\n\n.Image__mobile___9ZPib.Image__container___3NXZi {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"container": "Image__container___3NXZi",
	"img": "Image__img___2fY-M",
	"mobile": "Image__mobile___9ZPib"
};